<template>
  <div>
    <div>
      <intalio-form-builder
        settings="">
      </intalio-form-builder>
    </div>
  </div>
</template> 

<script>
"use strict"
import constants from '@/assets/js/constants.js';
import _ from '@/assets/js/dynamic-froms';
export default {
  name: 'formioRender',
  data() {
    return {
    }
  },
  beforeMount() {
  },
  mounted() {
    const el = document.querySelector('intalio-form-builder');
    el.settings = '{"level":"advance","backendSetting":{"url":"http://localhost:5000/api/DynamicForms/Save","header":""},"builderFilter":{"id":0,"templateName":"","templateId":"0","referenceNumber":"","structureId":"0","categoryId":"0"}}';
  },
  methods: {
  }
};
</script>



<style>
.v-application code {
  padding: 0 !important;
}
</style>